module.exports = __webpack_public_path__ + "img/CW_Robert_Ellis-7303668.6b0fe5cf.jpg";